import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Active extends Component {
  render () {
    const { active, color = {} } = this.props
    const { activeColor, inactiveColor } = Object.assign({
      activeColor: '#12ce7d',
      inactiveColor: '#c1c1c1'
    }, color)

    return (
      <div style={{ color: active ? activeColor : inactiveColor }} title={active ? 'Yes' : 'No'}>⬤</div>
    )
  }
}

Active.propTypes = {
  active: PropTypes.bool.isRequired,
  color: PropTypes.object
}
